(function () {
  function initBespokeCollection() {
    var sidebar = document.querySelector('[data-nxedc-bespoke-sidebar]');
    if (!sidebar) return;

    var openBtn = sidebar.querySelector('[data-nxedc-bespoke-filter-open]');
    var closeBtn = sidebar.querySelector('[data-nxedc-bespoke-filter-close]');

    function openSidebar() {
      sidebar.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      sidebar.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openSidebar);
    if (closeBtn) closeBtn.addEventListener('click', closeSidebar);

    sidebar.querySelectorAll('[data-nxedc-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var filter = btn.closest('.nxedc-bespoke-filter');
        if (!filter) return;
        var collapsed = filter.classList.toggle('is-collapsed');
        btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      });
    });

    var sortSelect = document.querySelector('[data-nxedc-bespoke-sort]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    var grid = document.querySelector('[data-nxedc-bespoke-grid]');
    var gridModes = document.querySelector('[data-nxedc-bespoke-grid-modes]');
    if (grid && gridModes) {
      var savedCols = localStorage.getItem('nxedc-bespoke-grid-cols') || '4';
      grid.setAttribute('data-grid-cols', savedCols);
      gridModes.querySelectorAll('.nxedc-bespoke-grid-mode').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-grid-cols') === savedCols);
        btn.addEventListener('click', function () {
          var cols = btn.getAttribute('data-grid-cols');
          grid.setAttribute('data-grid-cols', cols);
          localStorage.setItem('nxedc-bespoke-grid-cols', cols);
          gridModes.querySelectorAll('.nxedc-bespoke-grid-mode').forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBespokeCollection);
  } else {
    initBespokeCollection();
  }

  document.addEventListener('shopify:section:load', initBespokeCollection);
})();
